<div class="status_inf small_radius {{className}}">{{ statusName }}</div>
